/* LP Kit Experimentação · Alpes GO (tema Horizon) — um IIFE, sem dependências.
   Compra: limpa o carrinho, adiciona o kit, grava o atributo _lp_source e leva para /cart com as UTMs.
   No /cart o YampiSnippet do tema manda para o checkout da Yampi (mesmo caminho do botão de compra da loja).
   Estados: ready · soldout ("Kits esgotados") · missing (produto do kit não escolhido no editor). */
(() => {
  const root = document.querySelector('[data-lpk]');
  if (!root) return;
  root.classList.add('lpk-js');

  let CONFIG = {};
  try { CONFIG = JSON.parse(document.querySelector('[data-lpk-config]').textContent); } catch (e) {}
  const ctas = [...root.querySelectorAll('[data-cta]')];
  const toast = root.querySelector('[data-lpk-toast]');
  let state = !CONFIG.variantId ? 'missing' : CONFIG.available ? 'ready' : 'soldout';

  const showToast = (msg) => {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(showToast.t);
    showToast.t = setTimeout(() => toast.classList.remove('is-visible'), 3200);
  };

  // UTMs e click ids da URL seguem para o /cart (o YampiSnippet lê de lá e leva ao checkout)
  const trackingParams = () => {
    const keep = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', 'ttclid'];
    const now = new URLSearchParams(location.search);
    const out = new URLSearchParams();
    keep.forEach((k) => now.get(k) && out.set(k, now.get(k)));
    return out;
  };
  const cartUrl = () => {
    const q = trackingParams(); q.set('ref', 'yampi_buy_button');
    return `/cart?${q.toString()}`;
  };
  const post = (url, body) => fetch(url, {
    method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body || {}),
  }).then((r) => { if (!r.ok) throw new Error(url); return r.json(); });

  if (state === 'ready') {
    // Sem JS (ou clique do meio): adiciona pelo GET da Shopify e cai no /cart
    ctas.forEach((a) => (a.href = `/cart/add?id=${CONFIG.variantId}&quantity=1`));
  } else if (state === 'soldout') {
    root.classList.add('is-soldout');
    ctas.forEach((a) => {
      a.removeAttribute('href');
      a.setAttribute('aria-disabled', 'true');
      a.textContent = 'Kits esgotados';
    });
  }

  const buy = async (a) => {
    a.classList.add('loading');
    try {
      await post('/cart/clear.js');
      await post('/cart/add.js', { items: [{ id: CONFIG.variantId, quantity: 1 }] });
      await post('/cart/update.js', { attributes: { _lp_source: CONFIG.source || 'lp-kit-experimentacao' } });
      if (CONFIG.coupon) await fetch(`/discount/${encodeURIComponent(CONFIG.coupon)}`, { credentials: 'same-origin' }).catch(() => {});
      location.href = cartUrl();
    } catch (e) {
      location.href = `/cart/add?id=${CONFIG.variantId}&quantity=1`;
    }
  };

  ctas.forEach((a) =>
    a.addEventListener('click', (e) => {
      (window.dataLayer = window.dataLayer || []).push({ event: 'lp_kit_cta_click', cta_position: a.dataset.cta, cta_state: state });
      e.preventDefault();
      if (state === 'ready') buy(a);
      else if (state === 'missing') showToast('Os kits ficam disponíveis em instantes.');
    })
  );

  // Barra fixa (com miniatura, celular e desktop): aparece quando o botão do hero sai da tela e some no rodapé
  const sticky = root.querySelector('[data-lpk-sticky]');
  const heroCta = root.querySelector('[data-hero-cta]');
  const footer = root.querySelector('[data-lpk-footer]');
  if (sticky && heroCta && 'IntersectionObserver' in window) {
    const seen = { hero: true, footer: false };
    const sync = () => {
      const on = !seen.hero && !seen.footer;
      sticky.classList.toggle('is-visible', on);
      sticky.setAttribute('aria-hidden', String(!on));
      sticky.querySelector('a').tabIndex = on ? 0 : -1;
    };
    new IntersectionObserver(([e]) => { seen.hero = e.isIntersecting; sync(); }).observe(heroCta);
    if (footer) new IntersectionObserver(([e]) => { seen.footer = e.isIntersecting; sync(); }).observe(footer);
  }

  // Abas das avaliações (Treino · Rotina · Energia): cada depoimento em uma aba só, abre na primeira
  root.querySelectorAll('[data-lpk-reviews]').forEach((box) => {
    const tabs = [...box.querySelectorAll('[data-filter]')];
    const reviews = [...box.querySelectorAll('[data-tags]')];
    const show = (tab) => {
      tabs.forEach((t) => t.setAttribute('aria-selected', String(t === tab)));
      reviews.forEach((r) => (r.hidden = r.dataset.tags !== tab.dataset.filter));
    };
    tabs.forEach((tab) => tab.addEventListener('click', () => show(tab)));
    show(tabs.find((t) => t.getAttribute('aria-selected') === 'true') || tabs[0]);
  });

  // Vídeo das fundadoras: loop sem som, toca só na tela; o botão liga/desliga o som
  const founder = root.querySelector('[data-founder-video]');
  const sound = root.querySelector('[data-founder-sound]');
  if (founder) {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) { founder.removeAttribute('autoplay'); founder.pause(); }
    else if ('IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => (e.isIntersecting ? founder.play().catch(() => {}) : founder.pause()), { threshold: 0.3 }).observe(founder);
    }
    sound?.addEventListener('click', () => {
      founder.muted = !founder.muted;
      if (!founder.muted) { founder.currentTime = 0; founder.play().catch(() => {}); }
      sound.setAttribute('aria-pressed', String(!founder.muted));
      sound.setAttribute('aria-label', founder.muted ? 'Ligar o som' : 'Desligar o som');
    });
  }

  // Vídeos da comunidade: troca o poster pelo vídeo com som e pausa os outros
  // (o botão vira um <div> com o <video>: controles de vídeo não podem ficar dentro de um <button>)
  root.querySelectorAll('[data-lpk-ugc] button.lpk-video').forEach((btn) =>
    btn.addEventListener('click', () => {
      root.querySelectorAll('.lpk-video video').forEach((o) => o.pause());
      const box = document.createElement('div');
      box.className = 'lpk-video is-playing';
      const v = document.createElement('video');
      v.src = btn.dataset.src;
      v.poster = btn.querySelector('img').src;
      v.controls = true; v.playsInline = true; v.autoplay = true;
      v.setAttribute('aria-label', btn.getAttribute('aria-label'));
      box.append(v);
      btn.replaceWith(box);
      v.play().catch(() => {});
      v.addEventListener('play', () => root.querySelectorAll('.lpk-video video').forEach((o) => o !== v && o.pause()));
    })
  );

  // Entrada suave
  const reveals = root.querySelectorAll('.lpk-reveal');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    }), { threshold: 0.12 });
    reveals.forEach((el) => io.observe(el));
  } else reveals.forEach((el) => el.classList.add('is-in'));
})();
